import { render, staticRenderFns } from "./follow_main.vue?vue&type=template&id=001e2abd&scoped=true&"
import script from "./follow_main.vue?vue&type=script&lang=js&"
export * from "./follow_main.vue?vue&type=script&lang=js&"
import style0 from "./follow_main.vue?vue&type=style&index=0&id=001e2abd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001e2abd",
  null
  
)

export default component.exports